import { CircleCheck, CircleDashed, Hourglass, TriangleAlert, Unlink, type LucideIcon } from 'lucide-react';
import type { IndustryLinkState } from '@/services/companies.service';
import { INDUSTRY_OPTIONS } from '@/config/industries';

export const LINK_META: Record<IndustryLinkState, {
  label: string;
  /** One line for tooltips and the detail card. */
  explain: string;
  icon: LucideIcon;
  chip: string;
  tone: 'success' | 'danger' | 'warning' | 'info' | 'muted';
}> = {
  linked: {
    label: 'Linked',
    explain: 'The CRM runs as this industry — AI bot, departments and packs all match.',
    icon: CircleCheck,
    chip: 'bg-success-soft text-success',
    tone: 'success',
  },
  mismatch: {
    label: 'Mismatch',
    explain: 'The CRM runs as a different industry than the one assigned here.',
    icon: TriangleAlert,
    chip: 'bg-danger-soft text-danger',
    tone: 'danger',
  },
  awaiting_onboarding: {
    label: 'Onboarding pending',
    explain: 'The company hasn’t finished onboarding. Its CRM will open locked to this industry.',
    icon: Hourglass,
    chip: 'bg-info-soft text-info',
    tone: 'info',
  },
  crm_only: {
    label: 'Not assigned here',
    explain: 'The company picked an industry in the CRM, but nothing is assigned in super-admin.',
    icon: Unlink,
    chip: 'bg-warning-soft text-warning',
    tone: 'warning',
  },
  unset: {
    label: 'No industry',
    explain: 'No industry yet. The company will be asked to pick one at onboarding.',
    icon: CircleDashed,
    chip: 'bg-surface-alt text-text-muted',
    tone: 'muted',
  },
};

export const industryLabel = (key?: string | null) =>
  key ? (INDUSTRY_OPTIONS.find((o) => o.value === key)?.label ?? key) : null;

export const industryGroup = (key?: string | null) =>
  key ? INDUSTRY_OPTIONS.find((o) => o.value === key)?.group : undefined;
